import { tryLoadDependencies, WebAwesomeComponent } from '../Global/loadDependecy'
import { TemplateNavHeaderStyles } from './NavHeader.styles'

const t = document.createElement('template')
t.innerHTML = `
  <wa-icon name="bell" class="header-icon bell-icon" label="Notifications"
    aria-label="Notifications"
    alt="Notifications"
    aria-hidden="false"
    focusable="true"
    tabindex="0"
  ></wa-icon>
`

class NavHeaderUtilityBell extends HTMLElement {
  constructor() {
    super()

    tryLoadDependencies(document, [WebAwesomeComponent.Icon])

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(TemplateNavHeaderStyles.content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))
  }

  connectedCallback() {
    console.log('NavHeaderUtilityBell connectedCallback', this)
  }
}

if (!customElements.get('ts-navheader-utility-bell')) {
  customElements.define('ts-navheader-utility-bell', NavHeaderUtilityBell)
}
export { NavHeaderUtilityBell }
